import { Button } from '@material-ui/core';
import { Box} from '@mui/system';
import styled from 'styled-components';


export const MainContainer = styled(Box)`
${({ theme: { breakpoints } }) => `
 Display: flex; 
 flex-direction: column;
 justify-content: space-around;
 position: relative;
 top: 230px;
 margin-bottom: 250px;


 ${breakpoints.up('md')} { 
    flex-direction: row;
    top:-30px;
}
 `}
 `
 

 export const ResultsContainer = styled(Box)`
 ${({ theme: { breakpoints, colors} }) => ` 
 background-color: ${colors.oranges.orange1};
 display: flex;
 flex-direction: column;
 margin-top:60px;

 justify-content: center;
 align-items: center;
 border-radius: 0 0 120px 0;
 padding: 30px 0;
 `}
 `

 export const DisclaimerContainer = styled(Box)`
 ${({ theme: { breakpoints, colors} }) => ` 
p {font-size: 12px; color: ${colors.greens.green0}; }
 `}
 `

 export const CalculatorContainer = styled(Box)`
 ${({ theme: { breakpoints, colors} }) => ` 
border: 1px solid ${colors.greens.green0};
display: flex;
flex-direction: column;
margin-right: 40px;
padding: 30px;
background-color:${colors.whites.white1};


width: 100%;
 ${breakpoints.up('md')} { 
 width: 50%
}

 `}
 `

 export const ResultsMainContainer = styled(Box)`
 ${({ theme: { breakpoints} }) => ` 
 width: 100%;
  ${breakpoints.up('md')} { 
  width: 50%
}
`}
 `

 export const ResultsTitle = styled.h3 `
 ${({ theme: { breakpoints, colors} }) => `
 color: ${colors.oranges.orange2};
 font-size: 32px;
 margin: 0 0 15px 0;
 `}`

 export const ResultsSection = styled.span `
 ${({ theme: { breakpoints, colors} }) => `
 color: ${colors.oranges.orange2};
 font-size:27px;
 margin-bottom: 15px;
 `}`


 export const Results = styled(Box)`
 
 `

